/* Nuvō collection filters (loaded by sections/nuvo-collection-hero.liquid).
   Shopify only offers Availability and Price until filters are set up in its Search & Discovery app, so this panel
   builds its own from the collection's product data: category, material, size, ignition, gas type and price.
   Every product is on the page (the template shows up to 50), so filtering just shows and hides cards: OR within a
   group, AND across groups. The choice is kept for the tab, so changing the sort order keeps the filters. */
(() => {
  const handle = (location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1];
  if (!handle) return;
  const STORE = 'ncf:' + handle;

  const MATERIALS = ['Powder Coat', 'Stainless Steel', 'Corten Steel', 'Hammered Copper', 'GFRC Concrete', 'GFRC Woodgrain'];
  const TYPE_LABEL = { 'Fire Pits & Tables': 'Fire Tables', 'Outdoor Kitchen Accessories': 'Kitchen Accessories' };
  const PRICES = [
    ['Under $2,500', 0, 2500], ['$2,500 – $5,000', 2500, 5000], ['$5,000 – $10,000', 5000, 10000], ['$10,000 and up', 10000, Infinity],
  ];
  const ignition = (v) => /match/i.test(v) ? 'Match lit' : /110v|plug/i.test(v) ? 'Electronic, 110V plug & play'
    : /12v|low voltage/i.test(v) ? 'Electronic, 12V low voltage' : /spark/i.test(v) ? 'Spark ignition' : null;
  const gas = (v) => /natural/i.test(v) ? 'Natural gas' : /propane/i.test(v) ? 'Liquid propane' : null;

  /* the facets each product has, as { group: Set(values) } */
  const facetsOf = (p) => {
    const f = { category: new Set(), material: new Set(), size: new Set(), ignition: new Set(), gas: new Set(), price: new Set() };
    if (p.product_type) f.category.add(TYPE_LABEL[p.product_type] || p.product_type);
    p.tags.forEach((t) => { if (MATERIALS.includes(t)) f.material.add(t); if (t === 'Gas Selectable') { f.gas.add('Natural gas'); f.gas.add('Liquid propane'); } });
    p.options.forEach((o, i) => {
      const vals = new Set(p.variants.map((v) => v['option' + (i + 1)]).filter(Boolean));
      vals.forEach((v) => {
        if (/size/i.test(o.name)) { const m = v.match(/(\d+)\s*"/); if (m) f.size.add(m[1] + '"'); }
        else if (/ignition/i.test(o.name)) { const x = ignition(v); if (x) f.ignition.add(x); }
        else if (/gas|fuel/i.test(o.name)) { const x = gas(v); if (x) f.gas.add(x); }
      });
    });
    const min = Math.min(...p.variants.map((v) => parseFloat(v.price)));
    PRICES.forEach(([label, lo, hi]) => { if (min >= lo && min < hi) f.price.add(label); });
    return f;
  };

  const GROUPS = [
    ['category', 'Category'], ['material', 'Material'], ['size', 'Size'], ['ignition', 'Ignition'], ['gas', 'Gas type'], ['price', 'Price'],
  ];
  const ORDER = { size: (a, b) => parseInt(a, 10) - parseInt(b, 10), price: (a, b) => PRICES.findIndex((x) => x[0] === a) - PRICES.findIndex((x) => x[0] === b) };

  let byId = {};
  let picked = {};
  try { picked = JSON.parse(sessionStorage.getItem(STORE)) || {}; } catch (err) {}
  /* a link can open the collection filtered to one category (the home page circles: ?category=Fire Bowls) */
  const askedFor = new URLSearchParams(location.search).get('category');
  if (askedFor) {
    picked = { category: [askedFor] };
    /* from here on the panel owns the choice, so a reload after changing it keeps the change */
    const u = new URL(location.href); u.searchParams.delete('category'); history.replaceState(history.state, '', u);
  }
  const save = () => { try { sessionStorage.setItem(STORE, JSON.stringify(picked)); } catch (err) {} };
  const active = () => Object.values(picked).some((v) => v && v.length);

  const panel = document.createElement('div');
  panel.className = 'ncf';
  const mobile = document.createElement('details');
  mobile.className = 'ncf-m';
  mobile.innerHTML = '<summary><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 5h14M6 10h8M8.5 15h3"/></svg><span>Filters</span><b class="ncf-m__n"></b></summary>';

  const matches = (id) => {
    const f = byId[id];
    if (!f) return !active();
    return GROUPS.every(([g]) => !(picked[g] && picked[g].length) || picked[g].some((v) => f[g].has(v)));
  };

  const apply = () => {
    const cards = document.querySelectorAll('#main-collection-products > .grid-item[data-product-id]');
    let shown = 0;
    cards.forEach((c) => { const ok = matches(c.dataset.productId); c.classList.toggle('ncf-out', !ok); if (ok) shown++; });
    const count = document.querySelector('.collection-product-count');
    if (count) {
      if (!count.dataset.orig) count.dataset.orig = count.textContent.trim();
      const text = active() ? `${shown} of ${cards.length} pieces` : count.dataset.orig;
      if (count.textContent !== text) count.textContent = text;
    }
    let empty = document.querySelector('.ncf-empty');
    if (active() && !shown) {
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'ncf-empty';
        empty.innerHTML = '<p>No pieces match these filters.</p><button type="button" class="ncf-clear">Clear filters</button>';
        document.getElementById('main-collection-products')?.after(empty);
      }
    } else if (empty) empty.remove();
    const n = Object.values(picked).reduce((s, v) => s + (v ? v.length : 0), 0);
    mobile.querySelector('.ncf-m__n').textContent = n ? String(n) : '';
  };

  const render = (counts) => {
    let html = '<div class="ncf__head"><p class="ncf__title">Filters</p>' + (active() ? '<button type="button" class="ncf-clear">Clear all</button>' : '') + '</div>';
    GROUPS.forEach(([g, label]) => {
      const vals = Object.keys(counts[g]).sort(ORDER[g] || ((a, b) => counts[g][b] - counts[g][a] || a.localeCompare(b)));
      if (vals.length < 2) return;
      const on = picked[g] || [];
      html += `<div class="ncf__group" data-g="${g}"><div class="ncf__gh"><p>${label}</p>${on.length ? `<button type="button" class="ncf__reset" data-g="${g}">Reset</button>` : ''}</div><ul>`;
      vals.forEach((v, i) => {
        html += `<li${i >= 6 ? ' class="ncf__extra"' : ''}><button type="button" class="ncf__opt${on.includes(v) ? ' is-on' : ''}" data-g="${g}" data-v="${v.replace(/"/g, '&quot;')}" aria-pressed="${on.includes(v)}"><i></i><span>${v}</span><em>${counts[g][v]}</em></button></li>`;
      });
      html += '</ul>' + (vals.length > 6 ? '<button type="button" class="ncf__more">Show more</button>' : '') + '</div>';
    });
    panel.innerHTML = html;
  };

  let counts = null;
  const refresh = () => { render(counts); apply(); };

  panel.addEventListener('click', (e) => {
    const opt = e.target.closest('.ncf__opt');
    if (opt) {
      const { g, v } = opt.dataset;
      const list = picked[g] || (picked[g] = []);
      const i = list.indexOf(v);
      if (i < 0) list.push(v); else list.splice(i, 1);
      save(); refresh();
      return;
    }
    const reset = e.target.closest('.ncf__reset');
    if (reset) { delete picked[reset.dataset.g]; save(); refresh(); return; }
    const more = e.target.closest('.ncf__more');
    if (more) { const grp = more.closest('.ncf__group'); grp.classList.toggle('is-open'); more.textContent = grp.classList.contains('is-open') ? 'Show less' : 'Show more'; }
  });
  document.addEventListener('click', (e) => { if (e.target.closest('.ncf-clear')) { picked = {}; save(); refresh(); } });

  /* desktop: in the left column, in place of the theme's two filters; phones: a "Filters" fold above the grid */
  const place = () => {
    const aside = document.getElementById('main-collection-filters');
    const wide = aside && aside.offsetParent !== null && innerWidth >= 990;
    if (wide) { if (panel.parentNode !== aside) aside.appendChild(panel); mobile.remove(); }
    else {
      const toolbar = document.querySelector('.collection-toolbar-top');
      if (toolbar && mobile.parentNode !== toolbar.parentNode) toolbar.before(mobile);
      if (panel.parentNode !== mobile) mobile.appendChild(panel);
    }
  };

  const start = async () => {
    try {
      const r = await fetch(`/collections/${handle}/products.json?limit=250`, { headers: { Accept: 'application/json' } });
      const products = (await r.json()).products || [];
      counts = Object.fromEntries(GROUPS.map(([g]) => [g, {}]));
      products.forEach((p) => {
        const f = facetsOf(p);
        byId[p.id] = f;
        GROUPS.forEach(([g]) => f[g].forEach((v) => { counts[g][v] = (counts[g][v] || 0) + 1; }));
      });
    } catch (err) { return; }
    if (askedFor && !counts.category[askedFor]) delete picked.category;
    save();
    document.body.classList.add('ncf-on');
    place();
    refresh();
    addEventListener('resize', place);
    /* infinite scroll and sorting redraw the grid */
    const grid = document.getElementById('CollectionProducts');
    /* only new product cards count: the panel's own redraws happen inside this grid too */
    const isCard = (n) => n.nodeType === 1 && (n.matches('.grid-item') || n.querySelector('.grid-item'));
    if (grid) new MutationObserver((list) => {
      if (list.some((m) => [...m.addedNodes].some(isCard))) { place(); apply(); }
    }).observe(grid, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
